import { useInfiniteQuery, useQuery } from '@tanstack/react-query';

import { getStarlinkContent } from 'services';

import type { StarlinkHookType } from 'domains/starlink.d';

export const useStarlinkContent = <T>({
  cycle,
  document,
  page,
  page_size,
  segmentations,
  slug,
  year,
}: StarlinkHookType) => {
  return {
    ...useQuery({
      queryKey: [cycle, document, page, page_size, segmentations, slug, year],
      queryFn: () =>
        getStarlinkContent<T>({
          cycle,
          document,
          page,
          page_size,
          segmentations,
          slug,
          year,
        }),
      staleTime: 2 * 60 * 1000,
      refetchOnWindowFocus: false,
    }),
  };
};

export const useInfinityStarlinkContent = <T>({
  cycle,
  document,
  page_size,
  segmentations,
  slug,
  year,
}: StarlinkHookType) => {
  return {
    ...useInfiniteQuery({
      queryKey: [cycle, document, page_size, segmentations, slug, year],
      queryFn: ({ pageParam = 1 }) =>
        getStarlinkContent<T>({
          cycle,
          document,
          page: pageParam,
          page_size,
          segmentations,
          slug,
          year,
        }),
      staleTime: 2 * 60 * 1000,
      refetchOnWindowFocus: false,
      getNextPageParam: ({ pagination }) => {
        const currentPage = pagination.page ? pagination.page + 1 : 1;
        return currentPage <= pagination.totalPages ? currentPage : undefined;
      },
    }),
  };
};
